export enum AttributeLocationEnum {
  Kanban = 0,
  List = 1,
}